import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsADailyMotionAddress Returns whether the URL is a DailyMotion address
 * @param url
 */
export const urlIsADailyMotionAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.DailyMotion;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
